import React from "react";
import { BOOKS } from "../lib/siteData";
import { BookOpen } from "lucide-react";

export default function Books() {
  return (
    <section id="books" data-testid="books-section" className="py-20 sm:py-28">
      <div className="container-prose grid grid-cols-1 lg:grid-cols-12 gap-12">
        <aside className="lg:col-span-4 lg:sticky lg:top-28 self-start">
          <p className="overline">09 — Books & Publications</p>
          <h2 className="h2-display mt-4 text-4xl sm:text-5xl text-ink">
            Words that <span className="italic text-forest">travel</span> beyond the room.
          </h2>
          <p className="mt-6 body-prose text-ink/70 text-base sm:text-lg max-w-md">
            From TESOL Press contributions to a forthcoming book with TESOL Press / Routledge —
            Karamjeet's writing turns practice into transferable scholarship.
          </p>
        </aside>

        <div className="lg:col-span-8 space-y-6 sm:space-y-8">
          {BOOKS.map((b, i) => (
            <article
              key={i}
              data-testid={`book-${i}`}
              className="grid grid-cols-12 gap-6 border border-ink-10 bg-ivory p-6 sm:p-8 hover:shadow-[0_30px_60px_-30px_rgba(11,31,56,0.25)] transition-shadow"
              style={{ borderColor: "rgba(11,31,56,0.18)" }}
            >
              <div className="col-span-4 sm:col-span-3">
                <div
                  className="aspect-[3/4] flex items-center justify-center text-ivory relative shadow-[0_24px_40px_-20px_rgba(11,31,56,0.6)]"
                  style={{ background: b.accent }}
                >
                  <BookOpen size={28} className="opacity-50 absolute top-4 left-4" />
                  <p
                    className="px-4 text-center text-xl sm:text-2xl"
                    style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 500 }}
                  >
                    {b.title}
                  </p>
                </div>
              </div>
              <div className="col-span-8 sm:col-span-9">
                <p className="overline text-forest">{b.status}</p>
                <h3
                  className="mt-2 text-2xl sm:text-3xl text-ink"
                  style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 500 }}
                >
                  {b.title}
                </h3>
                <p className="mt-4 body-prose text-ink/75 text-[15px] sm:text-base leading-relaxed">
                  {b.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
